export default "/img/IQ.61143692374e167bcdf7bb3f695bfafa.png";